"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var Back = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tpointer-events: all;\n\tpadding-right: 8px;\n"], ["\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tpointer-events: all;\n\tpadding-right: 8px;\n"])));
var BackButton = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.breadcrumbs.backicon; });
var Crumbs = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tvertical-align: top;\n\tdisplay: inline-block;\n\t", "\n"], ["\n\tvertical-align: top;\n\tdisplay: inline-block;\n\t", "\n"])), function (props) { return props.theme.breadcrumbs.crumbs; });
var Crumb = styled_components_1.default.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\ttext-transform: uppercase;\t\n\t", "\n"], ["\n\ttext-transform: uppercase;\t\n\t", "\n"])), function (props) { return props.theme.breadcrumbs.crumb; });
var Breadcrumbs = /** @class */ (function (_super) {
    __extends(Breadcrumbs, _super);
    function Breadcrumbs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Breadcrumbs.prototype.render = function () {
        var _this = this;
        if (this.props.crumbs.length === 1 && !this.props.showSingle) {
            return null;
        }
        var showBack = this.props.crumbs.length > 1;
        var prevCrumbId = 0;
        if (showBack) {
            prevCrumbId = this.props.crumbs[this.props.crumbs.length - 2].id;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            showBack &&
                react_1.default.createElement(Back, { onClick: function () { return _this.props.onClick(prevCrumbId); }, "data-automationid": "breadcrumbs-close" },
                    react_1.default.createElement(BackButton, null, this.props.theme.svgs.scroll_up)),
            react_1.default.createElement(Crumbs, null, this.props.crumbs.map(function (crumb) {
                return (react_1.default.createElement(Crumb, { key: crumb.id, onClick: function () { return _this.props.onClick(crumb.id); }, "aria-label": crumb.name, "data-automationid": "breadcrumb-" + crumb.id },
                    react_1.default.createElement("span", null, crumb.name)));
            }))));
    };
    Breadcrumbs.propTypes = {
        crumbs: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            id: prop_types_1.default.string.isRequired,
            name: prop_types_1.default.string.isRequired
        })),
        onClick: prop_types_1.default.func.isRequired,
        /** string to show next to the back button */
        backMsg: prop_types_1.default.string,
        /** will show a crumb even when there's only one*/
        showSingle: prop_types_1.default.bool
    };
    Breadcrumbs.defaultProps = {
        crumbs: [
            { id: 'test', name: 'test' }
        ],
        onClick: function () { },
    };
    return Breadcrumbs;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Breadcrumbs);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Breadcrumbs.js.map